import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './app.postcss'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

let Cacher = (rel = 'preload', href, asMode = 'fetch', crossOrigin = true) => {
  var preloadLink = document.createElement('link')
  preloadLink.href = href
  preloadLink.rel = rel
  preloadLink.as = asMode
  preloadLink.crossOrigin = crossOrigin
  document.head.appendChild(preloadLink)
}

// eslint-disable-next-line
Cacher('preload', require('file-loader!./Model/jellyfish-paid/jellyfish.glb'), 'fetch')
// eslint-disable-next-line
Cacher('preload', require('file-loader!./Textures/maps/waterdudv.jpg'), 'image')
// Fonts JSON for THREE.JS
import('./Fonts/lovelo-bold.json')
